import { X } from 'lucide-react';
import { usePlayerController } from './PlayerProvider';
import { usePlayerStore } from './playerStore';
import { shallow } from 'zustand/shallow';

export function QueueDrawer() {
  const { selectEpisode, openQueue } = usePlayerController();
  const queue = usePlayerStore((state) => state.queue);
  const currentEpisodeId = usePlayerStore((state) => state.currentEpisodeId);
  const isQueueOpen = usePlayerStore((state) => state.isQueueOpen);

  if (!isQueueOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center">
      <div className="absolute inset-0 bg-neutral/50 backdrop-blur-sm" onClick={() => openQueue(false)} />
      <div className="relative w-full max-w-2xl rounded-t-2xl bg-base-100 shadow-2xl border border-base-300 p-4 max-h-[70vh]">
        <div className="flex items-center justify-between mb-3">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-base-content/60">Up Next</p>
            <h3 className="font-semibold text-lg">Episode Queue</h3>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={() => openQueue(false)} aria-label="Close queue">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="space-y-2 overflow-y-auto max-h-[60vh] pr-1">
          {queue.map((episode, idx) => {
            const isActive = episode.id === currentEpisodeId;
            return (
              <button
                key={episode.id}
                className={`w-full text-left p-3 rounded-xl border ${
                  isActive ? 'border-primary bg-primary/10' : 'border-base-300 bg-base-200/60'
                } hover:border-primary transition`}
                onClick={() => {
                  selectEpisode(episode.id);
                  openQueue(false);
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 rounded-lg overflow-hidden bg-base-300 flex-shrink-0">
                    {episode.coverImage ? (
                      <img src={episode.coverImage} alt={episode.title} className="h-full w-full object-cover" />
                    ) : (
                      <div className="h-full w-full bg-base-300" />
                    )}
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs text-base-content/60">Episode {episode.episodeNumber ?? idx + 1}</p>
                    <p className="font-medium truncate">{episode.title}</p>
                    <p className="text-xs text-base-content/60 truncate">{episode.seriesTitle}</p>
                  </div>
                </div>
              </button>
            );
          })}
          {queue.length === 0 && (
            <div className="text-center text-base-content/60 py-6 text-sm">No episodes in queue yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}
